import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import * as fromLoader from './+state/loader.reducer'
import { LoaderFacade } from './+state/loader.facade'
import { EffectsModule } from '@ngrx/effects'
import { LoaderEffects } from './+state/loader.effects'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromLoader.loaderFeatureKey, fromLoader.LoaderReducer),
    EffectsModule.forFeature([LoaderEffects]),
  ],
  providers: [LoaderFacade],
})
export class SharedUtilsLoaderModule {}
